// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
// hooks
import useAuth from './hooks/useAuth';
// components
import Settings from './components/settings';
import RtlLayout from './components/layouts/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import NotistackProvider from './components/NotistackProvider';
import ThemePrimaryColor from './components/ThemePrimaryColor';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useEffect } from 'react';
import { LicenseManager } from 'ag-grid-enterprise';
import { aggridLicenceKey } from './config';
import { store } from './redux/store';
import { Provider } from 'react-redux';

export default function App() {
  LicenseManager.setLicenseKey(aggridLicenceKey);

  setLocalstrage()
  function setLocalstrage() {
    let urlParamStr = window.location.search
    if (urlParamStr) {
      urlParamStr = urlParamStr.substring(1)
      urlParamStr.split('&').forEach(param => {
        const temp = param.split('=')
        // console.log(temp)
        localStorage.setItem(temp[0], temp[1])
      })
    }
  }

  const { isInitialized } = useAuth();

  useEffect(() => {
    // // 毎回実行される
  }, []);

  return (
    <Provider store={store}>
      <ThemeConfig>
        <ThemePrimaryColor>
          <RtlLayout>
            <NotistackProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Settings />
                <ScrollToTop />
                {isInitialized ? <Router /> : <LoadingScreen />}
              </LocalizationProvider>
            </NotistackProvider>
          </RtlLayout>
        </ThemePrimaryColor>
      </ThemeConfig>{' '}
    </Provider>
  );
}
